"use client";

import { useCallback, useState } from "react";

import { useProjectFilters } from "./useProjectFilters";

interface UseProjectFilterDrawerOptions {
  role: string;
}

export function useProjectFilterDrawer({ role }: UseProjectFilterDrawerOptions) {
  const [open, setOpen] = useState(false);
  const { applyFilters, syncDraftFromApplied, resetAutoSelection, ...filters } = useProjectFilters({
    role,
  });

  const handleOpenChange = useCallback(
    (nextOpen: boolean) => {
      if (nextOpen) {
        resetAutoSelection();
        syncDraftFromApplied();
      }
      setOpen(nextOpen);
    },
    [resetAutoSelection, syncDraftFromApplied]
  );

  const handleApply = useCallback(() => {
    applyFilters();
    setOpen(false);
  }, [applyFilters]);

  return {
    open,
    handleOpenChange,
    handleApply,
    ...filters,
  };
}
